import { VatPatternDto } from './vatpatterndto';
import { PaginationFeaturesDto } from '../paginationfeaturesdto';

export class VatPatternRequest {

    vatPatternDto: VatPatternDto = new VatPatternDto();

    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}